import { useCallback } from 'react'
import { useQueryParams, StringParam, ArrayParam } from 'use-query-params'

import { SHIPPINGS_STATIC_DEFAULT_FILTERS } from '../../common/constants'

import { STATUS_CODE_FILTER_ORDER } from './constants'

export const haveFiltersDefaultDatePeriod = ({ dateFrom, dateTo }) =>
  dateFrom === SHIPPINGS_STATIC_DEFAULT_FILTERS.dateFrom &&
  dateTo === SHIPPINGS_STATIC_DEFAULT_FILTERS.dateTo

export const getShippingTrackingDefaultFilters = baseFilters => ({
  ...SHIPPINGS_STATIC_DEFAULT_FILTERS,
  ...baseFilters,
})

export const patchFiltersSortingStatusCodes = filters => {
  if (!filters.statusCode) return filters
  if (filters.statusCode.length === 0) return filters

  const { statusCode: unsortedStatusCodes } = filters

  const sortedStatusCodes = STATUS_CODE_FILTER_ORDER.reduce(
    (accumulator, statusCode) => {
      if (!unsortedStatusCodes.includes(statusCode)) return accumulator

      accumulator.push(statusCode)
      return accumulator
    },
    [],
  )

  return {
    ...filters,
    statusCode: sortedStatusCodes,
  }
}

const filterParamsConfig = {
  clientCode: StringParam,
  postalCodeSource: StringParam,
  clientCenterCode: StringParam,
  centres: StringParam,
  search: StringParam,
  statusCode: ArrayParam,
  postalCodeFrom: StringParam,
  postalCodeTo: StringParam,
  originPostalCode: StringParam,
  destinPostalCode: StringParam,
  country: StringParam,
  serviceType: StringParam,
  dateFrom: StringParam,
  dateTo: StringParam,
  shippingsPage: StringParam,
  shippingsRowsPerPage: StringParam,
  shippingsSortType: StringParam,
  shippingsSortColumn: StringParam,
  incidentsPage: StringParam,
  incidentsRowsPerPage: StringParam,
  incidentsSortType: StringParam,
  incidentsSortColumn: StringParam,
  returnsPage: StringParam,
  returnsRowsPerPage: StringParam,
  returnsSortType: StringParam,
  returnsSortColumn: StringParam,
}

const useQueryParamsFilters = dynamicBaseFilters => {
  const defaultFilters = getShippingTrackingDefaultFilters(dynamicBaseFilters)

  const [filters, _setFilters] = useQueryParams(filterParamsConfig)

  const setFilters = useCallback(
    (newFilters, updateType) => {
      if (newFilters.centres !== undefined) {
        const serializedCentres = Array.isArray(newFilters.centres)
          ? newFilters.centres.map(centre => centre.hideId).join(',')
          : newFilters.centres
        const modifiedFilters = newFilters.clientCenterCode
          ? {
              ...newFilters,
            }
          : {
              ...newFilters,
              centres: serializedCentres,
            }
        const newFiltersQuery = patchFiltersSortingStatusCodes(modifiedFilters)
        _setFilters(newFiltersQuery, updateType)
      } else {
        const newFiltersQuery = patchFiltersSortingStatusCodes(newFilters)
        _setFilters(newFiltersQuery, updateType)
      }
    },
    [_setFilters],
  )

  const handleReplaceFilter = ({ searchType, value }) => {
    setFilters(
      {
        shippingsPage: '0',
        incidentsPage: '0',
        returnsPage: '0',
        [searchType]: value,
      },
      'replaceIn',
    )
  }

  //For pagination & sorting changes
  const handleUpdatePrevFilters = newFilters => {
    const result = { ...filters, ...newFilters }
    setFilters(result, 'push')
  }

  //For changes made with complex filters modal
  const handleUpdateDefaultFilters = newFilters => {
    setFilters(
      {
        ...defaultFilters,
        ...newFilters,
        shippingsPage: '0',
        incidentsPage: '0',
        returnsPage: '0',
      },
      'push',
    )
  }

  const handleClearFilters = () => setFilters(defaultFilters, 'push')

  return {
    filters,
    handleReplaceFilter,
    handleUpdatePrevFilters,
    handleUpdateDefaultFilters,
    handleClearFilters,
  }
}

export default useQueryParamsFilters
